import { cn, TextButton } from '@yanolja-rnd/nol-design-system'

import { useLogin } from '~/app/utils/useLogin'

interface LoginBannerProps {
  className?: string
  onClickLogin?: () => Promise<void>
}

const LoginBanner = ({ className, onClickLogin }: LoginBannerProps) => {
  const { onLogin } = useLogin()
  const handleLogin = async () => {
    await onClickLogin?.()
    onLogin({ isReplaceHistory: false })
  }

  return (
    <div
      className={cn(
        'flex w-full items-center justify-center gap-8 bg-static-white p-16',
        className
      )}
    >
      <div className="text-text-neutral-sub typography-body-13-regular">
        로그인하고 NOL 회원 전용 특가를 확인해 보세요.
      </div>
      <TextButton
        theme="underline"
        weight="bold"
        mobileSize="medium"
        pcSize="medium"
        onClick={handleLogin}
        className="min-h-fit p-0 pf-pc:min-h-fit"
      >
        로그인하기
      </TextButton>
    </div>
  )
}

export default LoginBanner
